const Base64 = require('./Base64');
const Audio = require('./Audio');

function formatDuration(duration) {
	const sec = duration % 60;
	const min = Math.floor(duration / 60);

	return `${min > 0 ? min + 'm' : ''}${sec > 0 ? sec + 's' : ''}`;
}

function datestamp_old( ts ) {
	const date = ts ? new Date(ts) : new Date();
	return date.getFullYear() + '-' + String(date.getMonth()+1).padStart( 2, "0" ) + '-' + String(date.getDate()).padStart( 2, "0" );
}

function datestamp( time, utc ) {
	let date;
	if ( time ) {
		date = ( time instanceof Date ) ? time : new Date(time);
	} else {
		date = new Date();
	}

	const part = {
		year: date[utc ? 'getUTCFullYear' : 'getFullYear' ](),
		month: date[utc ? 'getUTCMonth' : 'getMonth' ]() + 1,
		day: date[utc ? 'getUTCDate' : 'getDate' ](),
	};

	return `${part.year}-${String(part.month).padStart( 2, "0" )}-${String(part.day).padStart( 2, "0" )}`;
}

function clock() {
	const start = Date.now();
	return () => ( ( Date.now() - start ) / 1000 );
}

module.exports = {
	Base64,
	Audio,
	formatDuration,
	datestamp,
	//datestamp_utc,
	clock
};